export default __webpack_public_path__ + "static/media/eazyask-viewer-experience.b6ab83b7.gif";